/* @flow */
import AuthActions from 'auth/AuthActions';
import CurrentUser from 'auth/CurrentUser';
import DeviceActions from 'actions/DeviceActions';
import DeviceStore from 'stores/DeviceStore';
import setupCriteria from './setupCriteria';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

const RequireSetup = {
  statics: {
    onEnter(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void, callback: Function) {
      const requireSetup = (user) => {
        // XXX This comment implies that it was looking at the previous route, but this was never
        // the case. It was always looking at the route that is being transitioned to, not from.
        /* If we come from the SetupDefaultView or any other setup step
         * Then set the default redirection to the Groups route.
         * This is to ensure that nobody will be stuck and a blank page.
         */
        if (nextState.location.pathname.startsWith('/setup')) {
          replaceWith('/classes');
          callback();
          return;
        }

        if (!user.getRole()) {
          replaceWith('/information_required');
          callback();
          return;
        }

        /* Fetch all the possible routes from setupCriteria and
         * transition to the first eligible route for the current role.
         *
         * When a setup step is finished it can to transition either to:
         *
         * - this.context.router.push('/')
         *   - to show the next setup screen (if any) or transition to Groups.
         *
         * - this.context.router.push('SomeRoute')
         *   - to exit the setup flow and transition to SomeRoute.
         */
        const transitionToNextSetupStep = () => {
          const eligibleStep = setupCriteria.getNextEligibleStep(user.getRole());
          if (eligibleStep) {
            replaceWith(eligibleStep);
          }
          callback();
        };

        if (DeviceStore.isLoaded()) {
          transitionToNextSetupStep();
        } else {
          DeviceActions.loadDevices().then(transitionToNextSetupStep, transitionToNextSetupStep);
        }
      };

      if (CurrentUser.isSignedIn()) {
        requireSetup(CurrentUser.getUser());
      } else {
        AuthActions.checkLoggedIn().then(user => {
          if (user) {
            requireSetup(user);
          } else {
            callback();
          }
        }, callback);
      }
    },
  },
};

export default RequireSetup;



// WEBPACK FOOTER //
// ./src/setup/utils/RequireSetup.js